<template>
  <Container type="card-full" v-loading="loading">
    <div class="view-container">
      <div class="view-box">
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目编号</div>
            <div class="view-value">{{ project.projectcode }}</div>
          </div>
          <div class="view-field">
            <div class="view-label">平台编号</div>
            <div class="view-value">{{ project.projectno }}</div>
          </div>
          <div class="view-field">
            <div class="view-label">采购人</div>
            <div class="view-value">{{ project.pcomfullname }}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目名称</div>
            <div class="view-value">{{ project.projectname }}</div>
          </div>
          <div class="view-field">
            <div class="view-label">报名开始时间</div>
            <div class="view-value">{{project.prsbmbegtime | newDate}}</div>
          </div>
          <div class="view-field">
            <div class="view-label">报名截止时间</div>
            <div class="view-value">{{project.prsbmendtime | newDate}}</div>
          </div>
        </div>
        <!-- <div class="split-line"></div>
        <div class="view-row">
          <div class="view-field type">
            <div class="view-label">状态</div>
            <div class="view-value">
              <el-select v-model="query.status" :clearable="true" placeholder="全部">
                <el-option
                  v-for="item in pjnoticetypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="view-field">
          <div><el-button @click="getPageList" type='primary'>查询</el-button></div>
          <div class="view-value"></div>
          </div>
        </div> -->
      </div>
    </div>
    <!-- <div class="split-line"></div> -->
  
    <vggrid ref="xGrid" @pagechange=pagechange :list="isShowBmList" tableheight="600" flexname="" :cols="cols" :showfooter="false" :showPage="true"
      :resizable="true" :total="query.total" @cellClick="cellClick" @cellDblClick="viewProject">
      <template slot="btn">
        <div class="info">
        <el-button @click="rushbmFee" type="primary">催费</el-button>
        <el-button @click="senMsg" type="primary" v-if="isBeforeJJstartTimer">短信提醒报名人参加网上报价</el-button>
        <div class="info" style="width: 100%">
           <div style="display: flex; flex: 1;">
             <div class="info-item">
              <div class="el-icon-user icon"></div>
              <p>报名<span class="red">{{psuCount.bmnum}}</span>家</p>
            </div>
            <div class="info-item">
              <div class="el-icon-user icon"></div>
              <p class="ds">待审核<span class="red">{{Math.max(+psuCount.bmwsnum - +psuCount.expired_count - +psuCount.no_upload_count , 0)}}</span>家</p>
            </div>
            <div class="info-item">
              <div class="el-icon-user icon"></div>
              <p class="desc">审核通过<span class="red">{{psuCount.bmtgnum}}</span>家</p>
            </div>
            <div class="info-item" v-if="+project.projectbmamt > 0" style="margin-left: 15px;color: #67C23A">
              <p style="margin-right: 1px;">¥</p>
              <p class="desc">支付报名费<span class="red">{{psuCount.bmfnum}}</span>家</p>
            </div>
            <div class="info-item" v-if="+project.projectbzjamt > 0" style="color: #67C23A">
              <p style="margin-right: 1px;">¥</p>
              <p class="desc">支付保证金<span class="red">{{psuCount.bzjnum}}</span>家</p>
            </div>
           </div>
           <div class="button-group" v-show="+loginUser.comtype === 1">
              <div>
                <el-button  style="width: 110px;float: right;margin-right: 5px;margin-bottom: 10px;margin-top:12px;" type="primary" size="small" @click="exportToExcel" icon="el-icon-download">导出EXCEL</el-button>
              </div>
              <el-radio-group v-model="buttonStatus" size="small"" @input="buttonRadioChange">
                <el-radio-button :label="1">待审</el-radio-button>
                <el-radio-button :label="3">已审</el-radio-button>
                <el-radio-button :label="0">全部</el-radio-button>
              </el-radio-group>
            </div>
            </div>
        </div>
      </template>
    </vggrid>
  </Container>
</template>
<script>
import request from "@/utils/request";
import MenuBtn from "../common/menuBtn";
import vggrid from "../common/vggrid";
import common from "@/mixin/common";
import dayjs from "dayjs";
import utils from "../../assets/js/utils";
import * as XLSX from 'xlsx'
import FileSaver from 'file-saver'
export default {
  name: "BMXXlist",
  mixins: [common],
  data() {
    return {
      buttonStatus: 0,
      project: {},
      btn: {},
      list: [],
      loading: false,
      pjnoticetypeList: [],
      loginUser: this.$store.getters.loginUser,
      psuCount: {
        "bmnum": 0,
        "bmtgnum": 0,
        "bmwsnum": 0,
        "bzjnum": 0,
        "bmfnum": 0
      },
      statistics: {
        bm: 0,
        ds: 0,
        ys: 0,
        bmf: 0,
        bzj: 0,
      },
      cols: [
        {
          field: "psucomfullname",
          fieldtype: "C",
          title: "报名单位",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "psuusername",
          fieldtype: "C",
          title: "报名人",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "usercode",
          fieldtype: "C",
          title: "登陆账号",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "psucontactmail",
          fieldtype: "C",
          title: "报名邮箱",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "psubmamt",
          fieldtype: "C",
          title: "报名费",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "psubzjamt",
          fieldtype: "C",
          title: "保证金",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "psuconfirmfeeamtdesc",
          fieldtype: "C",
          title: "服务费",
          calculExpr: "",
          addNewRowFlg: false,
        },
        {
          field: "psutime",
          fieldtype: "T",
          title: "报名时间",
          calculExpr: "",
          addNewRowFlg: false,
          formatter: ["toDateString", ""],
          width: 180,
        },
        {
          field: "psustatusdesc",
          fieldtype: "C",
          title: "状态",
          calculExpr: "",
          addNewRowFlg: false,
          width: 100,
          showOverflow: true,
          slots: {
            default: "default",
            default: ({ row }) => {
              if (+row.prsbmneedconfirm === 1 && +row.psustatus === 1 && row.psuAppendCount === 0 && dayjs(row.prsbmendtime).isBefore(dayjs())) {
                return [<span>无效</span>]
              } else {
                if (+row.projectisinvite === 1 && +row.psustatus === 3) {
                  return [<span>确认参加</span>]
                }
                if (+row.projectisinvite === 1 && +row.psustatus === 1) {
                  return [<span>待接受</span>]
                }
                if (+row.psustatus === 1) {
                  return [<span>待审</span>]
                } else if (+row.psustatus === 2) {
                  return [<span>驳回</span>]
                } else if (+row.psustatus === 3) {
                  return [<span>通过</span>]
                } else if (+row.psustatus === 4) {
                  return [<span>拒绝</span>]
                }
              }
            }
          }
        },
        {
          field: "psutypeCN",
          fieldtype: "C",
          title: "方式",
          calculExpr: "",
          addNewRowFlg: false,
          width: 80,
        },
        {
          field: "psuAppendMsg",
          fieldtype: "C",
          title: "附件",
          calculExpr: "",
          addNewRowFlg: false,
          width: 80,
        },
        {
          title: "操作 ",
          width: 100,
          showOverflow: true,
          slots: {
            default: "default",
            default: ({ row }) => {
              // 无效
              if (+row.prsbmneedconfirm === 1 && +row.psustatus === 1 && row.psuAppendCount === 0 && dayjs(row.prsbmendtime).isBefore(dayjs())) {
                return [
                  <vxe-button
                    type="primary"
                    onClick={this.batchConfirm.bind(this, row)}
                  >
                    查看
                  </vxe-button>,
                ]
              }
              if (
                // 待审- 报名截止时间小于当前时间 - 审核
                +row.psustatus === 1 && dayjs(row.prsbjbegtime).valueOf()>dayjs().valueOf()
              ) {
                if (+row.prsbmneedconfirm === 1 && row.psuAppendCount === 0) {
                   return [
                    <vxe-button
                      type="primary"
                      onClick={this.batchConfirm.bind(this, row)}
                    >
                      查看
                    </vxe-button>,
                  ];
                } else {
                  if (+row.psutype === 2) {
                     return [
                      <vxe-button
                        type="primary"
                        onClick={this.batchConfirm.bind(this, row)}
                      >
                        查看
                      </vxe-button>,
                    ];
                  } else {
                    return [
                      <vxe-button
                        type="primary"
                        onClick={this.batchConfirm.bind(this, row)}
                      >
                        审核
                      </vxe-button>,
                    ];
                  }
                  
                }
              } else {
                return [
                  <vxe-button
                    type="primary"
                    onClick={this.batchConfirm.bind(this, row)}
                  >
                    查看
                  </vxe-button>,
                ];
              }
            },
          },
        },
      ],
      query: {
        cosid: this.$store.getters.loginUser.cosid,
        projectid: this.$route.params.projectid,
        total: 0,
        limit: 20,
        offset: 0,
      },
    };
  },
  async created() {
    await this.getModel();
  },
  computed: {
    isShowBmList () {
      if (+this.$store.getters.loginUser.comtype !== 2) return this.list
      if (dayjs().isBefore(this.project.prsbjendtime) && +this.$store.getters.loginUser.comtype === 2 && +this.project.compisshowreglist === 2) {
        this.query.total = 0
        return []
      }else {
        return this.list
      }
     
    },
    isAdminOrCuser() {
      let { projectauserid } = this.project
      let { roletype, userid, rolecomtype } = this.$store.getters.loginUser
      if (+projectauserid === +userid || (+roletype === 1 && +rolecomtype === 1)) return true;
      else return false
    },
    isBeforeJJstartTimer() {
      let { prsbjendtime, projectjkactualendtime } = this.project

      if (dayjs(new Date()).unix() < dayjs(prsbjendtime).unix() && !projectjkactualendtime && this.isAdminOrCuser)
        return true
      else return false
    }
  },
  async activated() {
    this.init();
    await this.getModel();
    this.getPjnoticetypeList();
    this.getPageList();
    this.getCosList()
    this.getPsuCount()
    const user = this.$store.getters.loginUser
    let idx = this.cols.findIndex(item => item.title === '保证金支付方式')
    if (idx !== -1) this.cols.splice(idx, 1)
    if (Number(this.project.projectbzjamt) > 0 && +user.roletype === 2 && +user.rolecomtype === 1) {
      this.cols.splice(5, 0, {
        fieldtype: "C",
        title: "保证金支付方式",
        calculExpr: "",
        width: 120,
        addNewRowFlg: false,
        slots:  {
          default: ({ row }) => {
            return [<span>{`${+row.psubzjpayflg === 1 ? Number(row.psubzjpaytype) === 3 ? '线下支付' : (Number(row.psubzjpaytype) === 1 ? '支付宝支付':'微信支付') : ''}`}</span>]
          }
        }
      }
    )
    }
  },
  watch: {},
  components: { vggrid },
  filters: {
    newDate(value){
        return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : ''
      },
  },
  methods: {
    async buttonRadioChange () {
      this.lading = true
      if (this.buttonStatus !== 0) {
        this.query.status = this.buttonStatus
      } else {
        delete this.query.status
      }
      this.getPageList()
    },
    async exportToExcel () {
     this.loading = true
     let { list } = await request({
        method: "get",
        url: "/xmgl/project/getPsuInfoByProjectId",
        params: {...this.query, limit: 60},
      })
      const l = list.filter(row =>  { 
        if (+row.psustatus === 3  ) {
          if (Number(row.psubmamt) > 0) {
              if (+row.psubmpayflg !== 1) {
                return false
              }
          }
          if (Number(row.psubzjamt) > 0) {
            if (row.psubzjpayflg !== 1) {
              return false
            }
          }
          if (+row.prsbmneedconfirm === 1 && +row.psustatus === 1 && row.psuAppendCount === 0 && dayjs(row.prsbmendtime).isBefore(dayjs())) {
              return false
          }
          return true
        }
      })
      const cols = ['序号', '报名单位', '报名人', '报名电话', '报名邮箱', '报名时间', '单位地址', '单位联系电话' ]
      let data = l.map((item, index) => {
        let obj = {}
        obj['序号'] = index + 1
        obj['报名单位'] = item.psucomfullname
        obj['报名人'] = item.psucontactname
        obj['报名电话'] = item.psucontactphone
        obj['报名邮箱'] = item.psucontactmail
        obj['报名时间'] = dayjs(item.psutime).format('YYYY-MM-DD HH:mm:ss')
        obj['单位地址'] = item.comaddr
        obj['单位联系电话'] = item.comtel
        return obj
      })
      
      const worksheet = XLSX.utils.json_to_sheet(
        data,
        {
          header: cols
        }
      );

      const max_width = data.reduce((w, r) => Math.max(w, r['报名单位'].length), 10);
      worksheet["!cols"] = [{wch: 10} ,{ wch: max_width * 2.2 }, { wch: 12 },  { wch: 12 }, { wch: 12 }, { wch: 26 }, { wch: 34 }, { wch: 14 } ];
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      // 生成blob对象
      const blob = new Blob([XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' })], { type: 'application/octet-stream' });
      var wbout = XLSX.write(workbook, {bookType: "xlsx",bookSST: true,type: "array"});
      FileSaver.saveAs(
        new Blob([wbout], { type: "application/octet-stream" }),
        this.project.projectname + "报名信息表.xlsx"
      )
      this.loading = false
    },
    async init() {
      this.query = {
        cosid: this.$store.getters.loginUser.cosid,
        projectid: this.$route.params.projectid,
        total: 0,
        limit: 20,
        offset: 0,
      };
      this.buttonStatus = 0
      this.btnLoading = false;
      this.psu = {};
      this.list = [];
      this.project = {};
    },
    async getModel() {
      this.project = await request({
        method: "get",
        url: "/xmgl/project/findProjectById",
        params: this.query,
      });
    },
    async getPjnoticetypeList() {
      this.pjnoticetypeList = await request({
        url: "/kfgl/syscode/getSysCodeList",
        method: "get",
        params: { syscode: "psustatus" },
      });
    },
    async getPsustatusList() {
      this.psustatusList = await request({
        url: "/kfgl/syscode/getSysCodeList",
        method: "get",
        params: { syscode: "psustatus" },
      });
    },
    async getPsuCount () {
      this.loading = true
      this.psuCount = await request({
        url: "/cwgl/psuproject/psuCount",
        method: "get",
        params: { psuprojectid: this.$route.params.projectid },
      });
      this.loading = false
    },
    async pagechange( { currentPage, pageSize }) {
      this.query.limit = pageSize
      this.query.offset = (currentPage - 1) * pageSize
      await this.getPageList()
    },
    async getPageList() {
      this.loading = true;
      this.statistics = {
        bm: 0,
        ds: 0,
        ys: 0,
        bmf: 0,
        bzj: 0,
        isShowBmf: true,
        isShowBzj: true
      },
      await this.getPsustatusList();
      let res = await request({
        method: "get",
        url: "/xmgl/project/getPsuInfoByProjectId",
        params: this.query,
      });
      res.list.forEach((e) => {
        e.psutypeCN = +e.psutype === 1 ? "公开" : "邀请";
        if (+e.psutype === 2) {
          if (+e.psustatus === 1) {
            e.psustatusdesc = "待接受";
            this.statistics.ds += 1
          } else if (+e.psustatus === 3) {
            e.psustatusdesc = "己接受";
            this.statistics.ys += 1
          } else if (+e.psustatus === 4) {
            e.psustatusdesc = "己拒绝";
          }
        } else {
          if (+e.psustatus === 1) { 
            this.statistics.ds += 1
          } else if (+e.psustatus === 3) {
            this.statistics.ys += 1
          }
        }
        if (e.psuAppendCount > 0) {
          e.psuAppendMsg = "有";
        } else {
          e.psuAppendMsg = "无";
        }
        if (e.psucontactname && e.psucontactphone) {
          e.psuusername = e.psucontactname + " " + e.psucontactphone;
        }
        if (Number(e.psubmamt) > 0) {
          let bmpayment = "(未付)";
          if (+e.psubmpaytype > 0 && +e.psubmpayflg !== 2) {
            bmpayment = "(待确认)";
          }
          if (+e.psubmpayflg === 1) {
            this.statistics.bmf += 1
          } 
          if (+e.psubmpayflg === 1) {
            bmpayment = "(已付)";
          }
          e.psubmamt = utils.comdify(e.psubmamt) + bmpayment;
        }
        if (Number(e.psubmamt) == 0) {
          e.psubmamt = "免费";
          this.statistics.isShowBmf = false
        }

        if (Number(e.psubzjamt) > 0) {
          let bzjpayment = "(未付)";
          if (+e.psubzjpaytype > 0 && +e.psubzjpayflg != 2) {
            bzjpayment = "(待确认)";
          }
          if (+e.psubzjpayflg === 1) {
            bzjpayment = "(已付)";
          }
          if (+e.psubzjpayflg === 1) {
            this.statistics.bzj += 1
          }
          if (+e.psubzjreturnflg === 1) {
            bzjpayment = "(已退)";
          }
          e.psubzjamt = utils.comdify(e.psubzjamt) + bzjpayment;
        }
        if (Number(e.psubzjamt) === 0) {
          e.psubzjamt = "免费";
          this.statistics.isShowBzj = false
        }

        if (Number(e.psuconfirmfeeamt) > 0) {
          let psufeement = "(未付)";
          if (+e.psufeepaytype > 0 && +e.psufewreceive !== 2) {
            psufeement = "(待确认)";
          }
          if (+e.psufewreceive === 1) {
            psufeement = "(已付)";
          }
          e.psuconfirmfeeamtdesc =
            utils.comdify(e.psuconfirmfeeamt) + psufeement;
        }
        if (e.psuconfirmfeeamt === null) {
          e.psuconfirmfeeamtdesc = "";
        } else if (+e.psuconfirmfeeamt === 0) {
          e.psuconfirmfeeamtdesc = "免费";
        }
      });
      this.list = res.list;
      this.query.total = res.count[0].count;
      this.statistics.bm = this.list.length
      console.log(this.statistics , '----stat')
      this.loading = false;
    },
    btnClick(code) {
      this.$emit(code);
    },
    vggridClick(code, row) {
      this.psu = row;
      this.$emit(code, row);
    },
    btnmenuclick(btn) {
      this.btn = btn;
    },
    async cellClick(row) {
      this.psu = row.row;
    },
    async close() {
      this.$store.commit("close_tab", {
        routeName: this.$route.name,
        vm: this,
        newRouteName: "womIndex",
      });
    },
    async getCosList() {
      let res = await request({
        method: "get",
        url: "/ywgl/cos/getCosbyid",
        params: { cosid: this.$store.getters.loginUser.cosid },
      });

      if (+res[0].cosshowfwf === 1 && this.$store.getters.loginUser.comtype == '2') {
        this.cols.splice(5, 1)
      }
    },
    async viewProject(row) {
      this.psu = row.row;
      this.$router.push({
        name: "psuBmForm",
        params: { psuid: this.psu.psuid },
      });
    },
    async batchConfirm(row) {
      this.$router.push({ name: "psuBmForm", params: { psuid: row.psuid } });
    },
    async rushbmFee() {
      let model = {};
      model.projectid = this.$route.params.projectid;
      model.cosid = this.$store.getters.loginUser.cosid;
      let data = await request({
        method: "get",
        url: "/info/rush/getPaidPsuList",
        params: model,
      });
      let fwf = "";
      if (data.fwfcount) {
        fwf += `${data.fwfcount}位中标单位未缴服务费，`;
      }
      this.$confirm(
        `还有${data.bmfcount}位供应商未缴报名费，${data.bzjcount}位供应商未缴保证金，${fwf}是否确认催费`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          this.loading = true;
          let res = await request({
            method: "get",
            url: "/info/rush/rushFee",
            params: model,
          });
          if (+res.issuccess === 1) {
            this.$message.success("催缴成功");
          }
          this.loading = false;
        })
        .catch(() => { });
    },
    async senMsg() {

      let { projectid } = this.project
      let res = await request({
        url: '/xmgl/pbr/getPsuByprojectId',
        method: "get",
        params: { projectid }
      })

      if (+res.count === 0) {
        this.$message.warning("符合条件人数为0，不需要通知")
        return
      }

      this.$confirm(`是否确定发送短信`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {

        let data = await request({
          method: "post",
          url: "/info/rush/sendNotice",
          data: {
            projectid
          },
        });

        if (data.issuccess === 1) {
          this.$message.success(data.msg)
        }
      })
    }
  }
}
</script>
<style lang="scss">
.btn-box {
  overflow: hidden;

  .vxe-button {
    padding: 10px 10px;
    font-size: 16px;
  }
}

.type {
  display: flex;
  align-items: center;
}
.info {
  margin-left: 25px;
  display: flex;
  align-items: center;
  .info-item {
    display: flex;
    align-items: center;
    margin-right: 12px;
    font-size: 20px;
    font-weight: bold;
    color: #303133;
    .icon {
      font-size: 20px;
      margin-right: 1px;
      color: #409EFF;
    }
  }
  // .ds {
  //   color: #E6A23C;
  // }
  // .info {
  //   color: #67C23A;
  // }
  .red {
    color: red;
  }
  .button-group {
    display: flex;
    flex-direction: column;
  }
}
</style>
